import styled from 'styled-components'
export const Navbar = styled.div`
// height: 500px;
position: relative;
    background-size: cover;
    background-repeat: no-repeat;
background: url(https://nitish.musafirbazar.com/static/media/j11.jpg);
.laltain{
    position: absolute;
    left: 0px;
    top:0px;
 
}
.mmtlogo{
    position: absolute;
    left: 0px;
    top: -42px;
    // width: 13%;
}
.topdiv{
padding-top:20px;
height:70px;
display: flex;
gap: 10px;
flex-direction: row-reverse;

}
.button{
    width: 200px;
    margin: auto;
button{
    width: 200px;
      height: 50px;
      color: white;
      font-weight: 600;
      border:none;
      cursor: pointer;
      position: relative;
      top: -27px;
      font-size: 24px;
      border-radius: 25px;
      background: linear-gradient(
        to right,
        #8fdcfa 0%,
        #619ff0 50%,
        #6c9feb 50%,
        #3339e9 100%);
}
}
a{
  color: white;
  text-decoration: none;
}


`
